// extracted by mini-css-extract-plugin
export default {"modalHeader":"ModalHeader_modalHeader__Jxjdw","modalHeaderTitle":"ModalHeader_modalHeaderTitle__pCcfS","modalHeaderTechnologies":"ModalHeader_modalHeaderTechnologies__b6ZwI"};